import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { FaBroom } from 'react-icons/fa6';
import { FaCheck } from 'react-icons/fa';
import TagSelector from '../TagSelector';
import {
  TagSelectorModal,
  TagSelectorContent,
  TagSelectorHeader,
  CloseButton,
  HeaderActions,
  ActionButton
} from './styles';

const TagSelectorModalComponent = ({ 
  isOpen, 
  onClose, 
  tags, 
  selectedTags, 
  onTagToggle 
}) => {
  // Keep track of temporary selections - Move hooks before the early return
  const [tempSelectedTags, setTempSelectedTags] = useState([]);

  // Initialize temporary selections when modal opens
  useEffect(() => {
    if (isOpen) {
      setTempSelectedTags(selectedTags);
    }
  }, [isOpen, selectedTags]);

  if (!isOpen) return null;

  const handleClearSelection = () => {
    setTempSelectedTags([]);
  };

  const handleTagToggle = (tag) => {
    setTempSelectedTags(prev => {
      const isSelected = prev.some(t => t.id === tag.id);
      if (isSelected) {
        return prev.filter(t => t.id !== tag.id);
      }
      return [...prev, tag];
    });
  };

  const handleApply = () => {
    // Apply all changes at once
    const tagsToRemove = selectedTags.filter(tag => 
      !tempSelectedTags.some(t => t.id === tag.id)
    );
    const tagsToAdd = tempSelectedTags.filter(tag => 
      !selectedTags.some(t => t.id === tag.id)
    );

    // Remove tags first
    tagsToRemove.forEach(tag => onTagToggle(tag));
    // Then add new ones
    tagsToAdd.forEach(tag => onTagToggle(tag));
    
    onClose();
  };

  const handleCancel = () => {
    // Discard temporary changes
    setTempSelectedTags(selectedTags);
    onClose();
  };

  return (
    <TagSelectorModal>
      <TagSelectorContent>
        <TagSelectorHeader>
          <h3>Select Tags</h3>
          <HeaderActions>
            <ActionButton 
              onClick={handleClearSelection}
              disabled={tempSelectedTags.length === 0}
              variant="secondary"
            >
              <FaBroom /> Clear All
            </ActionButton>
            <ActionButton 
              onClick={handleApply}
              variant="primary"
            >
              <FaCheck /> Apply
            </ActionButton>
            <CloseButton onClick={handleCancel} title="Cancel">
              <FaTimes />
            </CloseButton>
          </HeaderActions>
        </TagSelectorHeader>
        <TagSelector
          tags={tags}
          selectedTags={tempSelectedTags}
          onTagToggle={handleTagToggle}
        />
      </TagSelectorContent>
    </TagSelectorModal>
  );
};

export default TagSelectorModalComponent; 